export function computeLogReturns(prices) {
    return prices.slice(1).map((price, index) => Math.log(price / prices[index]));
}


export const percentReturn = (sell, buy)=>{
    if (sell===0||buy===0){
        return 0
    }
    return (sell - buy) / buy;
}

export const costOfLoss = (pct)=>{return (1 / (1 - Math.abs(pct))) - 1;}

export function rollingStdev(values, windowSize) {
    let result = [];

    for (let i = 0; i <= values.length - windowSize; i++) {
        let window = values.slice(i, i + windowSize);
        let mean = window.reduce((sum, val) => sum + val, 0) / window.length;
        let stdev = Math.sqrt(window.reduce((sum, val) => sum + Math.pow((val / mean) - 1, 2), 0) / (window.length - 1));  // Change here for sample standard deviation
        result.push(stdev);
    }
    return  result;
}

export function rollingSum(values, windowSize) {
    let result = [];
    for (let i = 0; i <= values.length - windowSize; i++) {
        let window = values.slice(i, i + windowSize);
        let sum = window.reduce((sum, val) => sum + val, 0);
        result.push(sum);
    }
    return result;
}

export function logToPercentReturns(logReturns) {
    let cumulative = 0;
    return logReturns.map(logReturn => {
        cumulative += logReturn;
        return (Math.exp(cumulative) - 1);
    });
}

export function rollingAverage(values, windowSize) {
    let result = [];
    for (let i = 0; i <= values.length - windowSize; i++) {
        let window = values.slice(i, i + windowSize);
        let average = window.reduce((sum, val) => sum + val, 0) / windowSize;
        result.push(average);
    }
    return result;
}
